import { createSlice } from '@reduxjs/toolkit';

export const dashboardsSlice = createSlice({
  name: 'dashboards',
  initialState: {},
  reducers: {
    update: (state, action) => ({ ...state, ...action.payload }),
  },
});

export default dashboardsSlice.reducer;
